
import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListIap(filter, authorization) {
  const url = `${API_URL}/admin/in-app`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addIap(iap, authorization) {
  const url = `${API_URL}/admin/in-app/create`;
  return axios({
    url,
    method: 'post',
    data: iap,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateIap(iap, authorization) {
  const url = `${API_URL}/admin/in-app/update`;
  return axios({
    url,
    method: 'post',
    data: iap,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function removeIap(iap, authorization) {
  const url = `${API_URL}/admin/in-app/delete`;
  return axios({
    url,
    method: 'post',
    data: iap,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/iap.js